import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import "./ContentAds.scss";

const ContentAds = (): JSX.Element => {
  return (
    <div className="ContentAds">
      {/* <div className="ContentAds__ad ContentAds__ad--tall"></div> */}
      <a className="ContentAds__ad ContentAds__ad--blog" href="https://crometrics.com/articles/" target="_blank" rel="noreferrer">
        <StaticImage src="../../global/assets/blog.png" alt="Cro Metrics Blog" loading="eager"/>
      </a>
    </div>
  );
};
export default ContentAds;